<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <fIter-for-grid
          @renderGridWithFilter="setSearchedPageFilters"
          :gridSearchDataManual="searchedPageFilters"
          :PackageQueryState="gridSearchData.PackageQueryState"
        ></fIter-for-grid>
        <operator-popup
          :show="onShowOperatorPopup"
          :DataPackageCurrent="DataPackageCurrent"
          @finish="onfinish"
          @close="closeOperatorPopup"
        ></operator-popup>
        <cost-popup
          :show="onShowCostPopup"
          :DataPackageCurrent="DataPackageCurrent"
          @finish="onfinish"
          @close="closeCostPopup"
        ></cost-popup>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :pageSizeManual="pageSizeManual"
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('userSender') },
                { title: $t('OperatorChoice') },
                { title: $t('CustomerName') },
                { title: $t('RecipientName') },
                { title: $t('CostAndFreight') },
                { title: $t('SubmitCountOfCarton') },
                { title: $t('OrderNumber') },
                { title: $t('CreateOn') },
                { title: $t('SalePersonName') },
                { title: $t('Description') },
                { title: $t('PackageInfo') },
              ]"
            >
              <template slot-scope="{ row, pagination }">
                <td style="width: 9%">
                  {{
                    row.checkOutInfo ? row.checkOutInfo.issuerUserName : "---"
                  }}
                </td>
                <td style="width: 12%">
                  <vs-button
                    v-if="row.operatorInfo || row.transportInfo"
                    color="success"
                    type="gradient"
                    icon-pack="feather"
                    class="bordered-btn"
                    @click.prevent="ShowOperatorPopup(row)"
                    v-has-permission="permission236"
                    >{{ $t("EditOperator") }}</vs-button
                  >
                  <vs-button
                    v-else
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    class="bordered-btn"
                    @click.prevent="ShowOperatorPopup(row)"
                    v-has-permission="permission236"
                  >
                    {{ $t("SubmitOperator") }}
                  </vs-button>
                </td>
                <td style="width: 8%">
                  {{ row.partyName }}
                </td>
                <td style="width: 8%">
                  {{ row.recipientInfo.recipientName }}
                </td>
                <td style="width: 12%">
                  <vs-button
                    v-if="
                      row.billOfLadingNumber ||
                      row.cost ||
                      row.transportsFleetInfo
                    "
                    color="success"
                    type="gradient"
                    icon-pack="feather"
                    class="bordered-btn"
                    @click.prevent="ShowCostPopup(row)"
                    v-has-permission="permission237"
                  >
                    {{ $t("EditCostAndFreight") }}
                  </vs-button>
                  <vs-button
                    v-else
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    class="bordered-btn px-6"
                    @click.prevent="ShowCostPopup(row)"
                    v-has-permission="permission237"
                  >
                    {{ $t("SubmitCostAndFreight") }}
                  </vs-button>
                </td>
                <td style="width: 13%">
                  <div class="flex justify-center">
                    <vs-input
                      class="w-1/3 inputx pt-1 ml-4"
                      v-model="row.cartons"
                      v-if="row.isEditable"
                    />
                    <p class="mt-3 ml-4 mr-12" v-else>
                      {{
                        row.cartons ? row.cartons : row.cartons == 0 ? 0 : "---"
                      }}
                    </p>
                    <vs-button
                      radius
                      size="small"
                      color="success"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="d-inline mx-2 mt-2"
                      v-if="!row.isEditable"
                      @click.prevent="row.isEditable = !row.isEditable"
                    ></vs-button>
                    <vs-button
                      radius
                      size="small"
                      color="success"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-check"
                      class="d-inline w-1/4 mt-2"
                      v-if="row.isEditable"
                      @click.prevent="submitCountOfCarton(row)"
                    ></vs-button>
                  </div>
                  <!-- @click.prevent="submitCountOfCarton(row.id, row.carton); row.isEditable = false"                -->
                </td>
                <td style="width: 8%">
                  {{ row.draftOrderInfo ? row.draftOrderInfo.basketId : "---" }}
                </td>
                <td style="width: 7%; direction: ltr">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>

                <td style="width: 9%">
                  {{ row.salePersonInfo ? row.salePersonInfo.name : "---" }}
                </td>
                <td style="width: 11%; font-size: 10px">
                  {{ row.description ? row.description : "---" }} <br />
                  {{ row.considerations ? row.considerations : "" }}
                </td>
                <td style="width: 5%">
                  <router-link
                    :to="{
                      path: '/Package/Details/' + tabIndex + '/' + row.id,
                      query: {
                        gridSearchData,
                        numberRowsPerPage: pagination.pageSize,
                        breadcrumbNameManual: {
                          persianTitle: 'مرسولات',
                          Title: 'Package',
                        },
                      },
                    }"
                  >
                    <vs-button
                      radius
                      color="success"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="mx-4 d-inline"
                    ></vs-button>
                  </router-link>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import OperatorPopup from "../OperatorPopup.vue";
import CostPopup from "../CostPopup.vue";
import FIterForGrid from "../../../components/extra-components/FilterForGrid.vue";

export default {
  name: "",
  components: {
    DataGrid,
    OperatorPopup,
    CostPopup,
    FIterForGrid,
  },
  props: {
    tabIndex: { default: "" },
    searchedPageFilters: {},
    numberRowsPerPage: {
      default: -1,
    },
  },
  data() {
    return {
      permission236: "AssignOperatorToPackage",
      permission237: "AssignTransportFleetToPackage",
      pageSizeManual: 10,
      onShowCostPopup: false,
      onShowOperatorPopup: false,
      gridDataSource: { data: [] },
      gridSearchData: { PackageQueryState: "1", PackageType: "1" , ShipmentId:this.$route.query.ShipmentId},
      DataPackageCurrent: {},
      model: {},
      PackagesInfo: {},
    };
  },
  mounted() {
    this.pageSizeManual = this.numberRowsPerPage ? this.numberRowsPerPage : -1;
    this.gridDataSource = {
      type: "app",
      service: "Shipping/api/PackagesQuery",
    };

    if (this.searchedPageFilters.PackageQueryState) {
      this.setSearchedPageFilters(this.searchedPageFilters);
    } else {
      this.renderGrid();
    }
  },
  methods: {
    ...mapActions({
      PackageDelivered: "shipping/PackageDelivered",
      editCountOfCarton: "shipping/editCountOfCarton",
    }),
    ShowOperatorPopup(packageCurrent) {
      this.onShowOperatorPopup = true;
      this.DataPackageCurrent = packageCurrent;
    },
    ShowCostPopup(packageCurrent) {
      this.DataPackageCurrent = packageCurrent;
      this.onShowCostPopup = true;
    },
    setSearchedPageFilters(gridSearch) {
      this.gridSearchData = JSON.parse(JSON.stringify(gridSearch));
      this.gridSearchData.PackageQueryState = 1;
      this.renderGrid();
    },
    renderGrid() {
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 200);
    },
    PackageDeliveredToTransferee(packageId) {
      this.model.packageId = packageId;
      this.PackageDelivered(this.model).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "مرسوله موردنظر به مشتری تحویل داده شد",
          showConfirmButton: false,
          timer: 2000,
        });
      });
    },
    // submitCountOfCarton(packageId, cartonsCount) {
    submitCountOfCarton(row) {
      this.model.packageId = row.id;
      this.model.cartonsCount = row.cartons;
      if (row.cartons == "") {
        this.model.cartonsCount = 0;
      }
      this.editCountOfCarton(this.model).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "تعداد کارتن ثبت شد!",
          showConfirmButton: false,
          timer: 3000,
        });
        this.model = {};
        row.isEditable = false;
      });
    },
    closeOperatorPopup() {
      this.onShowOperatorPopup = false;
    },
    closeCostPopup() {
      this.onShowCostPopup = false;
    },
    onfinish() {
      this.closeCostPopup();
      this.closeOperatorPopup();
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 0);
    },
  },
};
</script>
